import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {ExamenDefinitionModel} from "../../../api/entity/examenDefinition.model";
import {AbstractRepositoryV2} from "../../../../../core/service/v2/abstractRepositoryV2";

@Injectable()
export class ExamenDefinitionRepository extends AbstractRepositoryV2<ExamenDefinitionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ExamenDefinition', serviceElementsFactory, injector);
    }
}
